import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Text from '../../../../atoms/Text';
import {
  isEVMAddress,
  isElrondAddress,
} from '../../../../helpers/checksumAddress';
import { IStore } from '../../../../reducers';
import { IMobileSearchButton } from '../../../../components/SearchTable/SearchTable';

import './styles.scss';

const MobileAnalyzeWallet = ({ search, onBack }: IMobileSearchButton) => {
  const navigate = useNavigate();

  const chain = useSelector((state: IStore) => state.wallet_watchlist.chain);

  const onAnalyze = () => {
    navigate(`/en/wallet-overview/${chain || 'ETH'}/${search}`);
    onBack();
  };

  const active = isEVMAddress(search) || isElrondAddress(search);

  return (
    <Text
      size={18}
      className={`mobile_analyze text--navy-600 ${
        active ? 'mobile_analyze--active' : 'mobile_analyze--normal'
      }`}
      onClick={active ? onAnalyze : undefined}
    >
      A
    </Text>
  );
};

export default MobileAnalyzeWallet;
